import { createBrowserRouter, Navigate } from 'react-router-dom';

import { LoginPage } from '../features/auth/LoginPage';
import { ProtectedRoute } from '../features/auth/ProtectedRoute';
import { SettingsLayout } from '../features/settings/SettingsLayout';
import { AppLayout } from './AppLayout';
import { RouteErrorPage } from './RouteErrorPage';
import { UnitAccessRoute } from '../features/units/UnitAccessRoute';
import { UnitLandingPage } from '../features/units/UnitLandingPage';
import { UnitSelectionPage } from '../features/units/UnitSelectionPage';
import { LogatecSettingsLayout } from '../features/logatec/LogatecSettingsLayout';
import {
  CostsSettingsRoute,
  GeneralSettingsRoute,
  ExecutedOrderMovesRoute,
  ProductDetailRoute,
  DashboardRoute,
  ProductFormRoute,
  ProductListRoute,
  MapRoute,
  NewOrderRoute,
  OrderDetailRoute,
  OrdersRoute,
  RackSettingsRoute,
  TagsRoute,
  UsersRoute,
  LogatecMapRoute,
  LogatecMapSettingsRoute,
  LogatecProductDetailRoute,
  LogatecProductFormRoute,
  LogatecProductListRoute,
} from './LazyRoutes';

export const router = createBrowserRouter([
  {
    path: '/prijava',
    element: <LoginPage />,
    errorElement: <RouteErrorPage />,
  },
  {
    path: '/',
    errorElement: <RouteErrorPage />,
    element: (
      <ProtectedRoute>
        <UnitLandingPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/enote',
    errorElement: <RouteErrorPage />,
    element: (
      <ProtectedRoute>
        <UnitSelectionPage />
      </ProtectedRoute>
    ),
  },
  {
    errorElement: <RouteErrorPage />,
    element: (
      <ProtectedRoute>
        <UnitAccessRoute unitCode="SKOFJA_LOKA">
          <AppLayout unitCode="SKOFJA_LOKA" />
        </UnitAccessRoute>
      </ProtectedRoute>
    ),
    children: [
      {
        path: 'izdelki',
        element: <ProductListRoute />,
      },
      {
        path: 'izdelki/nov',
        element: (
          <ProtectedRoute roles={['ADMIN', 'SKLADISCNIK']}>
            <ProductFormRoute />
          </ProtectedRoute>
        ),
      },
      {
        path: 'izdelki/:id',
        element: <ProductDetailRoute />,
      },
      {
        path: 'izdelki/:id/uredi',
        element: (
          <ProtectedRoute roles={['ADMIN', 'SKLADISCNIK']}>
            <ProductFormRoute />
          </ProtectedRoute>
        ),
      },
      {
        path: 'mapa',
        element: (
          <ProtectedRoute roles={['ADMIN', 'SKLADISCNIK']}>
            <MapRoute />
          </ProtectedRoute>
        ),
      },
      {
        path: 'narocila',
        element: <OrdersRoute />,
      },
      {
        path: 'narocila/novo',
        element: (
          <ProtectedRoute roles={['ADMIN', 'PAKER']}>
            <NewOrderRoute />
          </ProtectedRoute>
        ),
      },
      {
        path: 'narocila/izvedeni-premiki',
        element: <ExecutedOrderMovesRoute />,
      },
      {
        path: 'narocila/:id/uredi',
        element: <NewOrderRoute />,
      },
      {
        path: 'narocila/:id',
        element: <OrderDetailRoute />,
      },
      {
        path: 'dashboard',
        element: (
          <ProtectedRoute roles={['ADMIN', 'SKLADISCNIK']}>
            <DashboardRoute />
          </ProtectedRoute>
        ),
      },
      {
        path: 'nastavitve',
        element: (
          <ProtectedRoute roles={['ADMIN']}>
            <SettingsLayout />
          </ProtectedRoute>
        ),
        children: [
          { index: true, element: <UsersRoute /> },
          {
            path: 'tagi',
            element: <TagsRoute />,
          },
          { path: 'splosno', element: <GeneralSettingsRoute /> },
          { path: 'stroski', element: <CostsSettingsRoute /> },
          { path: 'regali', element: <RackSettingsRoute /> },
        ],
      },
    ],
  },
  {
    path: '/logatec',
    errorElement: <RouteErrorPage />,
    element: (
      <ProtectedRoute>
        <UnitAccessRoute unitCode="LOGATEC">
          <AppLayout unitCode="LOGATEC" />
        </UnitAccessRoute>
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to="mapa" replace /> },
      { path: 'izdelki', element: <LogatecProductListRoute /> },
      {
        path: 'izdelki/nov',
        element: (
          <ProtectedRoute roles={['ADMIN', 'SKLADISCNIK']}>
            <LogatecProductFormRoute />
          </ProtectedRoute>
        ),
      },
      { path: 'izdelki/:id', element: <LogatecProductDetailRoute /> },
      {
        path: 'izdelki/:id/uredi',
        element: (
          <ProtectedRoute roles={['ADMIN', 'SKLADISCNIK']}>
            <LogatecProductFormRoute />
          </ProtectedRoute>
        ),
      },
      { path: 'mapa', element: <LogatecMapRoute /> },
      {
        path: 'nastavitve',
        element: (
          <ProtectedRoute roles={['ADMIN']}>
            <LogatecSettingsLayout />
          </ProtectedRoute>
        ),
        children: [{ index: true, element: <LogatecMapSettingsRoute /> }],
      },
    ],
  },
]);
